import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { SystemDialogs } from '../constants/Dialogs';

export const openDialog = (dialog, draft) => Dispatcher.dispatch({type: ActionTypes.DIALOG_OPEN, payload: Object.assign({}, {dialog, draft})});
export const closeDialog = (dialog) => Dispatcher.dispatch({type: ActionTypes.DIALOG_CLOSE, dialog});

export default {
    open: openDialog,
    close: closeDialog,
    setDraft: (draft) => Dispatcher.dispatch({type: ActionTypes.DIALOG_DRAFT_SET, payload: Object.assign({}, {draft})}),
    updateDraft: (field, value) => Dispatcher.dispatch({type: ActionTypes.DIALOG_DRAFT_UPDATE, payload: Object.assign({}, {field, value})}),
    bulkUpdateDraft: (updates) => Dispatcher.dispatch({type: ActionTypes.DIALOG_DRAFT_BULK_UPDATE, payload: Object.assign({}, {updates})}),
    showMessageDialog: (message, title = '') => openDialog(SystemDialogs.MESSAGE_DIALOG, {title, message}),
    hideMessageDialog: () => closeDialog(SystemDialogs.MESSAGE_DIALOG),
};
